import styled from "styled-components";
import { Flex } from "../../styles/global.syles";

export const NavbarContainer = styled.nav`
  background: ${(props) =>
    !props.isFixed
      ? "linear-gradient(to bottom, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.88) 65%, rgba(255, 255, 255, 0) 100%)"
      : "rgba(255, 255, 255, 0.96)"};
  backdrop-filter: ${(props) => (props.shouldShow ? "blur(14px)" : "none")};
  -webkit-backdrop-filter: ${(props) => (props.shouldShow ? "blur(14px)" : "none")};
  position: ${(props) => (props.isFixed ? "fixed" : "relative")};
  top: ${(props) => (props.isFixed ? (props.shouldShow ? "0" : "-120px") : "0")};
  left: 0;
  right: 0;
  z-index: 9999;
  transition: all 0.3s ease-in-out;
  width: 100%;
  box-shadow: ${(props) =>
    props.shouldShow
      ? "0 4px 20px rgba(12, 21, 56, 0.08)"
      : "none"};
  border-bottom: ${(props) =>
    props.shouldShow ? "1px solid rgba(12, 21, 56, 0.06)" : "none"};

  .nav-backdrop {
    display: none;
    @media screen and (max-width: 1024px) {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(12, 21, 56, 0.45);
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
      z-index: 998;
    }
  }

  .container {
    position: relative;
    max-width: 1400px;
    margin: 0 auto;
    padding: ${(props) => (props.shouldShow ? "12px 36px" : "22px 36px")};
    transition: padding 0.3s ease;

    @media screen and (max-width: 1200px) {
      padding: ${(props) => (props.shouldShow ? "10px 24px" : "16px 24px")};
    }

    @media screen and (max-width: 768px) {
      padding: 14px 20px;
    }

    @media screen and (max-width: 480px) {
      padding: 12px 16px;
    }
  }

  .nav-header-flex {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    a {
      display: flex;
      align-items: center;
      text-decoration: none;
    }

    img {
      width: 165px;
      height: auto;
      object-fit: contain;
      transition: width 0.3s ease;

      @media screen and (max-width: 1200px) {
        width: 145px;
      }

      @media screen and (max-width: 640px) {
        width: 135px;
      }

      @media screen and (max-width: 400px) {
        width: 120px;
      }
    }
  }

  .links {
    display: flex;
    align-items: center;
  }

  .nav-menu-links {
    display: flex;
    align-items: center;
    gap: 24px;

    @media screen and (max-width: 1200px) {
      gap: 16px;
    }

    @media screen and (max-width: 1024px) {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      width: 100%;
      max-height: calc(100vh - 75px);
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      background: #ffffff;
      padding: 20px 20px 28px 20px;
      gap: 10px;
      box-shadow: 0 20px 40px rgba(12, 21, 56, 0.16);
      border-top: 1px solid rgba(12, 21, 56, 0.06);
      border-bottom: 3px solid #2806f9;
      border-radius: 0 0 20px 20px;
      transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
      transform: ${(props) => (props.shownav ? "translateY(0)" : "translateY(-16px)")};
      opacity: ${(props) => (props.shownav ? "1" : "0")};
      visibility: ${(props) => (props.shownav ? "visible" : "hidden")};
      pointer-events: ${(props) => (props.shownav ? "auto" : "none")};
      z-index: 999;
    }
  }

  /* Nav Links */
  .nav-item-link {
    font-size: 15.5px;
    font-weight: 500;
    text-decoration: none;
    color: #0c1538;
    white-space: nowrap !important;
    letter-spacing: -0.2px;
    display: inline-flex;
    align-items: center;
    padding: 6px 2px;
    position: relative;
    cursor: pointer;
    transition: color 0.2s ease, background-color 0.2s ease;

    @media screen and (max-width: 1200px) {
      font-size: 14.5px;
    }

    &.active {
      font-weight: 700;
      color: #2806f9;

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 2px;
        right: 2px;
        height: 2px;
        background: #2806f9;
        border-radius: 2px;
      }
    }

    &:hover {
      color: #2806f9;
    }

    @media screen and (max-width: 1024px) {
      font-size: 16px;
      font-weight: 600;
      padding: 12px 16px;
      width: 100%;
      text-align: left;
      border-radius: 12px;
      justify-content: flex-start;

      &:hover, &:active {
        background: rgba(40, 6, 249, 0.05);
        color: #2806f9;
      }

      &.active {
        background: rgba(40, 6, 249, 0.08);
        color: #2806f9;

        &::after {
          display: none;
        }
      }
    }
  }

  /* Download Item */
  .nav-download-item {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    text-decoration: none;
    white-space: nowrap !important;
    cursor: pointer;
    color: #0c1538;
    font-size: 15.5px;
    font-weight: 500;
    padding: 5px 12px;
    border-radius: 20px;
    background: rgba(12, 21, 56, 0.04);
    border: 1px solid rgba(12, 21, 56, 0.08);
    transition: all 0.2s ease;

    @media screen and (max-width: 1200px) {
      font-size: 14px;
      padding: 4px 10px;
      gap: 6px;
    }

    span {
      line-height: 1;
      display: inline-block;
      white-space: nowrap;
    }

    .apple-icon {
      font-size: 18px;
      color: #0c1538;
      display: flex;
      align-items: center;
      transition: color 0.2s ease;
    }

    .android-icon {
      width: 18px;
      height: 18px;
      object-fit: contain;
      display: flex;
      align-items: center;
    }

    &:hover,
    &.active {
      background: rgba(40, 6, 249, 0.08);
      border-color: rgba(40, 6, 249, 0.35);
      color: #2806f9;

      .apple-icon {
        color: #2806f9;
      }
    }

    @media screen and (max-width: 1024px) {
      padding: 12px 16px;
      font-size: 15px;
      font-weight: 600;
      border-radius: 12px;
      width: 100%;
      justify-content: flex-start;
      margin: 4px 0;
    }
  }

  /* Social Icons */
  .nav-social-wrap {
    display: flex;
    align-items: center;
    gap: 7px;
    white-space: nowrap;

    @media screen and (max-width: 1024px) {
      padding: 6px 16px;
      gap: 12px;
      width: 100%;
    }
  }

  .nav-social-btn {
    width: 33px;
    height: 33px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(12, 21, 56, 0.05);
    color: #0c1538;
    font-size: 14px;
    transition: all 0.25s ease;
    text-decoration: none;
    border: 1px solid rgba(12, 21, 56, 0.08);

    @media screen and (max-width: 1024px) {
      width: 38px;
      height: 38px;
      font-size: 16px;
    }

    &.tiktok:hover {
      background: #000000;
      color: #ffffff;
      border-color: #000000;
      transform: translateY(-2px);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
    }

    &.youtube:hover {
      background: #ff0000;
      color: #ffffff;
      border-color: #ff0000;
      transform: translateY(-2px);
      box-shadow: 0 4px 10px rgba(255, 0, 0, 0.35);
    }
  }

  /* Login Button */
  .nav-login-link {
    text-decoration: none;
    display: inline-flex;
    align-items: center;

    @media screen and (max-width: 1024px) {
      width: 100%;
    }
  }

  .nav-login-btn {
    color: #ffffff;
    font-size: 14px;
    padding: 9px 24px;
    text-align: center;
    border: 0;
    border-radius: 999px;
    font-family: inherit;
    font-weight: 700;
    background: #2806f9;
    cursor: pointer;
    white-space: nowrap !important;
    box-shadow: 0 4px 14px rgba(40, 6, 249, 0.3);
    transition: all 0.25s ease;

    &:hover {
      background: #1e03c2;
      transform: translateY(-1px);
      box-shadow: 0 6px 18px rgba(40, 6, 249, 0.45);
    }

    @media screen and (max-width: 1024px) {
      width: 100%;
      padding: 13px 0;
      margin-top: 6px;
      border-radius: 12px;
      font-size: 15px;
    }
  }

  /* Hamburger toggle button */
  .bars {
    background: transparent;
    border: none;
    outline: none;
    font-size: 24px;
    color: #0c1538;
    cursor: pointer;
    padding: 8px;
    min-width: 44px;
    min-height: 44px;
    display: none;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease, transform 0.2s ease;

    &:hover {
      color: #2806f9;
    }

    &:active {
      transform: scale(0.92);
    }

    @media screen and (max-width: 1024px) {
      display: flex;
    }
  }
`;
